
const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: '日期',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 150

      }
    ];
    for (let i = 1; i < 21; i++) {
      let obj = {};
      obj.title = i.toString();
      obj.align = 'center';
      let j = ('00' + i).slice(-2);
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        // console.log(row.num_history_json[j]);
        return <span class="">{row.num_history_json[j] || 0}</span>;
      };
      arr.push(obj);
    }
    var a = ['大', '小', '单', '双', '龙', '虎'];
    var keys = ['big', 'small', 'single', 'double', 'long', 'hu'];

    for (let i = 0; i < a.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = e;
      obj.align = 'center';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        if (i == 4) {
          var num = 0;
          for (let i = 1; i < 5; i++) {
            const e = `lh${i}`;
            num += row.num_history_json[e].long;
          }
          return <span>{num}</span>;
        } else if (i == 5) {
          var num = 0;
          for (let i = 1; i < 5; i++) {
            const e = `lh${i}`;
            num += row.num_history_json[e].hu;
          }
          return <span>{num}</span>;
        }
        return <span>{row.num_history_json[keys[i]] ? row.num_history_json[keys[i]] : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Lishihaomatongji/columns/hpten.js